module.exports = __webpack_public_path__ + "static/media/ispo-rgt-shape.983ad97a.svg";